<div class="window">
    <div class="header" [innerHTML]="title"></div> 
    <div class="content" [innerHTML]="message"></div>
    <div class="footer">
        <button *ngIf="continueText !== ''" type="button" class="continue" (click)="continue()">{{ continueText }}</button>
        <button *ngIf="cancelText !== ''" type="button" class="cancel" (click)="cancel()">{{ cancelText }}</button>
    </div>           
</div>
